import { gql } from '@apollo/client';
import { PROPERTY_NYBYGG_FRAGMENT } from '../fragments/propertyNybygg';

export const GET_PROPERTY_NYBYGG_PROFILE_QUERY = gql`
  ${PROPERTY_NYBYGG_FRAGMENT}
  query GetPropertyNybyggProfile($input: PropertyInput) {
    profile: getProperty(input: $input) {
      sold
      ...PropertyNybygg
    }
  }
`;
